import noop from 'lodash/noop';
import { useState } from 'react';

import type { Promotion } from 'services/shop/cart';
import { createHookContext } from '@clover-util/react-context';

export type AsyncPromotion =
  | {
      status: null | 'loading' | 'error';
      data: null;
    }
  | {
      status: 'success';
      data: Promotion;
    };

export interface IFetchingPromoContext {
  fetchingPromo: AsyncPromotion;
  setFetchingPromo: (promo: AsyncPromotion) => void;
}

export const initialFetchingPromoValue: AsyncPromotion = {
  status: null,
  data: null,
};

export const initialValue: IFetchingPromoContext = {
  fetchingPromo: initialFetchingPromoValue,
  setFetchingPromo: noop,
};

export const { useFetchingPromoInternal, FetchingPromoInternalProvider } = createHookContext(
  'FetchingPromoInternal',
  () => {
    const [fetchingPromo, setFetchingPromo] = useState<AsyncPromotion>(initialFetchingPromoValue);

    return {
      fetchingPromo,
      setFetchingPromo,
    };
  },
);
